import axios from "axios"
import { json } from "react-router-dom"

export const show = async ({ params }) => {
    return axios.get(`${process.env.REACT_APP_INVENTORY_API_URL}/attribute/group/${params.id}`).then((res) => res.data.data).catch((error) => {
        throw new json(error, error.response.status)
    })
}